import React from 'react'
import { Grid } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 1200,
  },
}))

export default function GridContainer({ children }) {
  const classes = useStyles()
  return <Grid container classes={classes} spacing={3}>{children}</Grid>
}